import { render, staticRenderFns } from "./DesignIframe.vue?vue&type=template&id=241308d5&"
import script from "./DesignIframe.vue?vue&type=script&lang=js&"
export * from "./DesignIframe.vue?vue&type=script&lang=js&"
import style0 from "./DesignIframe.vue?vue&type=style&index=0&global=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports